module.exports = "img/flags/AT.b4d4f35.png";